import type { SVGProps } from 'react'

interface WaterIconProps extends SVGProps<SVGSVGElement> {}

export function WaterIcon(props: WaterIconProps) {
  return (
    <svg
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_1136_2184)">
        <path
          d="M13.5063 0.827041C12.8486 -0.294857 12.1523 -0.256171 11.4946 0.827041C8.47707 5.31463 3.91211 12.046 3.91211 15.4117C3.91211 17.7716 4.87926 19.938 6.42671 21.4854C7.97415 23.0329 10.1406 24 12.5004 24C14.8603 24 17.0267 23.0329 18.5742 21.4854C20.1216 19.938 21.0887 17.7716 21.0887 15.4117C21.0887 12.0073 16.5238 5.31463 13.5063 0.827041ZM18.6902 19.2416C18.0712 20.2475 17.1814 21.1373 16.0982 21.7562C15.5953 22.027 14.9763 21.8723 14.7055 21.3694C14.396 20.8278 14.5895 20.2088 15.0924 19.938C15.8661 19.5124 16.4851 18.8935 16.9493 18.1584C17.4136 17.4234 17.6844 16.5723 17.7231 15.6825C17.7617 15.1022 18.226 14.6767 18.8063 14.7154C19.3866 14.754 19.8121 15.2183 19.7734 15.7986C19.696 17.0365 19.3092 18.1971 18.6902 19.2416Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1136_2184">
          <rect
            width="24"
            height="24"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
